<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-text-field
    v-model="model.value"
    :label="model.text"
    type="number"
    :min="0"
    :max="maxInt"
    :rules="[v => !v || (v >= 0 && v <= maxInt) || ' ']"
    hide-spin-buttons
    @input="$emit('update:model', { ...model, value: $event })"
  >
  </v-text-field>
</template>
<script>
import { ComponentModel } from '../../../model/ComponentModel'
import { MAX_INT } from '../../../util/constants'

export default {
  name: 'HdNumberField',
  props: {
		model: {
			type: ComponentModel,
			required: true,			
		}
	},
  computed: {
    maxInt() {
      return MAX_INT
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
